module.exports = "/layout/app/images/logo-payment-footer.84f11203.svg";